import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import AgreementFiles from './components/AgreementFiles';

const agreementFiles = (props, { t }) => (
  <Container>
    <AgreementFiles {...props} />
  </Container>
);

agreementFiles.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(agreementFiles);
